import {
  SEARCH_CLEAR,
  SEARCH_LOADING,
  SEARCH_PROPERTY_ADD,
  SEARCH_NAME_ADD,
  SEARCH_OTHER_ADD,
  SEARCH_IS_SELECTED_UPDATE,
  SearchIsSelectedUpdate,
  DocumentTypeName,
  DataTypeName,
  SearchShowReferncesUpdate,
  SEARCH_SHOW_REFERNCES_UPDATE,
  SearchExportTypeUpdate,
  SEARCH_EXPORT_TYPE_UPDATE,
  SEARCH_TOGGLE_SELECT_ALL,
  SEARCH_MULTI_ADD,
  ResultTypeName,
} from './Search.types';
import { Dispatch } from 'redux';
import { httpError, json, fetchPost, showWarnNotification } from 'common';
import {
  SearchByPropertyResult,
  SearchFormData,
  SearchByNameResultWithSearchCriteria,
  SearchByOtherResult,
} from './models';
import { bookTypeOptions, Tabs } from './SearchForm/consts';
import { SearchByMultiResult } from './models/result/SearchByMultiResult';

export function searchClear() {
  return {
    type: SEARCH_CLEAR,
  };
}

export function searchToggleSelectAll(
  dataTypeName: DataTypeName,
  documentType: string,
  selectAll: boolean,
  resultItemIndex: number,
  resultType: ResultTypeName,
) {
  return {
    type: SEARCH_TOGGLE_SELECT_ALL,
    payload: {
      dataTypeName,
      documentType,
      selectAll,
      resultItemIndex,
      resultType,
    },
  };
}

export function searchLoading(loading: boolean) {
  return {
    type: SEARCH_LOADING,
    payload: loading,
  };
}

export function searchPropertyAdd(data: SearchByPropertyResult) {
  return {
    type: SEARCH_PROPERTY_ADD,
    payload: data,
  };
}

export const searchIsSelectedUpdate = (
  dataTypeName: DataTypeName,
  documentType: DocumentTypeName,
  guid: string,
  isSelected: boolean,
  resultItemIndex: number,
  resultType?: ResultTypeName,
): SearchIsSelectedUpdate => ({
  type: SEARCH_IS_SELECTED_UPDATE,
  payload: {
    dataTypeName,
    documentType,
    guid,
    isSelected,
    resultItemIndex,
    resultType,
  },
});

export const searchShowReferncesUpdate = (
  dataTypeName: DataTypeName,
  documentType: DocumentTypeName,
  showReferences: boolean,
  resultItemIndex: number,
  resultType: ResultTypeName,
): SearchShowReferncesUpdate => ({
  type: SEARCH_SHOW_REFERNCES_UPDATE,
  payload: {
    dataTypeName,
    documentType,
    showReferences,
    resultItemIndex,
    resultType,
  },
});

export const searchExportTypeUpdate = (
  dataTypeName: DataTypeName,
  documentType: DocumentTypeName,
  exportType: string,
  resultItemIndex: number,
  resultType: ResultTypeName,
): SearchExportTypeUpdate => ({
  type: SEARCH_EXPORT_TYPE_UPDATE,
  payload: {
    dataTypeName,
    documentType,
    exportType,
    resultItemIndex,
    resultType,
  },
});

export function searchNameAdd(data: SearchByNameResultWithSearchCriteria) {
  return {
    type: SEARCH_NAME_ADD,
    payload: data,
  };
}

export function searchOtherAdd(data: SearchByOtherResult) {
  return {
    type: SEARCH_OTHER_ADD,
    payload: data,
  };
}

export function searchMultiAdd(data: SearchByMultiResult) {
  return {
    type: SEARCH_MULTI_ADD,
    payload: data,
  };
}

export function fetchAsync(params: SearchFormData, bearerToken: string) {
  const apiUri: string = process.env.REACT_APP_API_URI as string;

  let searchRequest: any = {
    hob: params.hob,
    from: params.from,
    to: params.to,
    bookType: params.bookType,
    bookTypeText: bookTypeOptions.find((x) => x.value == params.bookType)?.text,
    apn: params.apn,
    searchName: params.searchName,
    isOldSystem: params.isOldSystem,
  };

  const documentTypes: string[] = [];
  const documentTypesByBlockLot: string[] = [];
  const documentTypesByName: string[] = [];
  const documentTypesByAddress: string[] = [];

  switch (params.tab) {
    case Tabs.Property:
      if (params.propertyTab.assessment) documentTypes.push('assessment');
      if (params.propertyTab.filedLiens) documentTypes.push('liens');
      if (params.propertyTab.recordedDocuments)
        documentTypes.push('recordedDocuments');

      searchRequest = {
        documentTypes,
        ...searchRequest,
        ...params.propertyTab,
      };
      break;
    case Tabs.Name:
      if (params.nameTab.judgmentsLiens) documentTypes.push('liens');
      if (params.nameTab.ftl) documentTypes.push('federalTaxLiens');
      if (params.nameTab.parkingViolations)
        documentTypes.push('parkingViolationJudgments');
      if (params.nameTab.ecb)
        documentTypes.push('environmentalControlBoardJudgments');
      if (params.nameTab.tab)
        documentTypes.push('transitAdjudicationBureauJudgments');
      if (params.nameTab.ucc) documentTypes.push('uniformCommercialCodes');
      if (params.nameTab.recordedDocuments)
        documentTypes.push('recordedDocuments');

      searchRequest = {
        documentTypes,
        ...searchRequest,
        ...params.nameTab,
      };
      break;
    case Tabs.Other:
      searchRequest = {
        ...searchRequest,
        ...params.otherTab,
      };
      break;
    case Tabs.Multi:
      if (params.multiTab.assessment)
        documentTypesByBlockLot.push('assessment');
      if (params.multiTab.filedLiens) documentTypesByBlockLot.push('liens');
      if (params.multiTab.recordedDocumentsByBlockLot)
        documentTypesByBlockLot.push('recordedDocuments');

      if (params.multiTab.judgmentsLiens) documentTypesByName.push('liens');
      if (params.multiTab.ftl) documentTypesByName.push('federalTaxLiens');
      if (params.multiTab.parkingViolations)
        documentTypesByName.push('parkingViolationJudgments');
      if (params.multiTab.ecb)
        documentTypesByName.push('environmentalControlBoardJudgments');
      if (params.multiTab.tab)
        documentTypesByName.push('transitAdjudicationBureauJudgments');
      if (params.multiTab.ucc)
        documentTypesByName.push('uniformCommercialCodes');
      if (params.multiTab.recordedDocuments)
        documentTypesByName.push('recordedDocuments');

      if (params.multiTab.ecbsByAddress)
        documentTypesByAddress.push('environmentalControlBoardJudgments');
      if (params.multiTab.emergencyRepairs)
        documentTypesByAddress.push('emergencyRepairs');

      searchRequest = {
        documentTypesByBlockLot,
        documentTypesByName,
        documentTypesByAddress,
        ...searchRequest,
        ...params.multiTab,
      };
      break;
    default:
      break;
  }

  return (dispatch: Dispatch) => {
    dispatch(searchLoading(true));
    fetchPost(
      `${apiUri}/nycDatabase/searchBy${params.tab}`,
      searchRequest,
      bearerToken,
    )
      .then(httpError(dispatch))
      .then(json)
      .then((response) => {
        if (response.errorMessage) throw Error(response.errorMessage);
        return response;
      })
      .then(
        (
          result:
            | SearchByPropertyResult
            | SearchByNameResultWithSearchCriteria
            | SearchByOtherResult
            | SearchByMultiResult,
        ) => {
          dispatch(searchLoading(false));
          switch (params.tab) {
            case Tabs.Property:
              dispatch(searchPropertyAdd(result as SearchByPropertyResult));
              break;
            case Tabs.Name:
              dispatch(
                searchNameAdd(result as SearchByNameResultWithSearchCriteria),
              );
              break;
            case Tabs.Other:
              dispatch(searchOtherAdd(result as SearchByOtherResult));
              break;
            case Tabs.Multi:
              dispatch(searchMultiAdd(result as SearchByMultiResult));
              break;
            default:
              break;
          }
        },
      )
      .catch((error) => {
        dispatch(searchLoading(false));
        showWarnNotification(`Search`, error.message);
      });
  };
}
